import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import type { SharedAccessOutfitArticle } from '../../types/shared-access-outfits.type';

import './shared-outfit-article-image-grid.scss';

applyTranslations(require('./shared-outfit-article-image-grid.i18n.json'));

type Props = {
  articles: Array<SharedAccessOutfitArticle>
};

const SharedOutfitArticleImageGrid = (
  {
    articles
  }: Props
): JSX.Element => {
  const items = articles
    .map((_, index) => {
      const article = articles[index];
      const imageUrl = article?.imageUrl;
      if (imageUrl) {
        return (
          <a
            key={`outfit-image-grid-${imageUrl}-${index}`}
            href={article?.itemUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={imageUrl}
              className="shared-outfit-article-image-grid__image"
              alt=""
            />
          </a>
        );
      }

      return (
        <div
          key={`outfit-image-grid-${index}`}
          className="shared-outfit-article-image-grid__empty-item"
        >
          {__t('shared_outfit_article_image_grid.empty_item_label', { index: index + 1 })}
        </div>
      );
    });

  return (
    <section className="shared-outfit-article-image-grid">
      {items}
    </section>
  );
};

export default SharedOutfitArticleImageGrid;
